<template>
  <div id="page-user-edit">
    {{ /* LOADER */ }}
    <loading
        :active.sync="loader.isLoading"
        :can-cancel="false"
        :is-full-page="loader.fullPage"
        :opacity="loader.opacity"
        :color="loader.color"
    ></loading>

    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between">
      <div>
        <h5>
          {{ dataPage.title }} <strong>{{ UserModule.user.firstname }}  {{ UserModule.user.lastname }}</strong> ({{ UserModule.user.username }})
        </h5>
      </div>
      <div>
        <router-link
            class="btn btn-outline-primary mb-3"
            :to="{ name: 'user-index' }"
        >
          retour
        </router-link>
      </div>
    </div>

    {{ /* Form component */ }}
    <FormCrudUser
        :user="UserModule.user"
        :id="UserModule.user.id"
        :actionForm="'edit'"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data() {
    return {
      loader: {
        opacity: 0.9,
        isLoading: false,
        fullPage: true,
      },
      dataPage: {
        title: (this.$store.getters.userIsAdmin) ? this.$t('pages.user.editUserTitle') : this.$t('pages.user.editUserQuoteTitle'),
      }
    }
  },
  methods: {
    /*----------------- LOADER ------------------*/
    showLoader() {
      this.loader.isLoading = true
    },
    hideLoader() {
      this.loader.isLoading = false
    },
  },
  created() {
    this.showLoader()

    this.$store.dispatch('fetchUser', this.$route.params.id)
  },
  updated() {
    this.hideLoader()
  },
  computed: {
    ...mapState(['UserModule'])
  },
  components: {
    Loading: () => import('vue-loading-overlay'),
    FormCrudUser: () => import('@/components/pages/user/FormCrudUser')
  }
}
</script>

<style scoped>

</style>
